import React, { useEffect, useState } from "react";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        visible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-10 pointer-events-none"
      }`}
    >
      <button
        onClick={scrollToTop}
        className="relative w-16 h-16 flex items-center justify-center group"
      >
        {/* 🔥 Layer 1: Outer Glow */}
        <div className="absolute w-16 h-16 rounded-full bg-gradient-to-tr from-purple-500 via-pink-500 to-indigo-500 blur-xl opacity-70 group-hover:opacity-100 transition duration-500"></div>

        {/* 💎 Layer 2: Glass Circle */}
        <div className="absolute w-14 h-14 rounded-full bg-white/10 backdrop-blur-md border border-white/20 shadow-inner"></div>

        {/* ✨ Layer 3: Inner Button */}
        <div className="relative w-12 h-12 rounded-full bg-gradient-to-tr from-[#b31159] to-purple-600 flex items-center justify-center shadow-lg group-hover:scale-110 transition duration-300">

          {/* Arrow */}
          <div className="w-5 h-5 border-t-4 border-l-4 border-white rotate-45 transform group-hover:-translate-y-1 transition duration-300 shadow-[0_0_12px_rgba(255,255,255,0.9)]"></div>

        </div>

        {/* ⚡ Pulse Ring */}
        <div className="absolute w-16 h-16 rounded-full border border-pink-400 animate-ping opacity-20"></div>
      </button>
    </div>
  );
}

export default ScrollToTop;